/* eslint-disable no-case-declarations */
import {
  SET_LOOKAHEAD_ASSISTANCE_ACTIVATED_COLS,
  SET_LOOKAHEAD_ASSISTANCE_RANGE_FILTERED,
  NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE,
  NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_FILTER,
  NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_GROUP,
  NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_ORDER
} from '../actions/assistanceActions';

/**
 * Reducer function means a switch case to filter action data on the platform for general state
 * @param {*} state Real time updated through all components state (general state flux)
 * @param {*} action Action is an object with structyure { type: STRING, payload: FUNCTION }
 */
function lookaheadReducer(
  state = {
    activatedColumns: [],
    isRangeDateFiltered: false,
    dateRangeToFilter: [],
    notifyChange: false,
    notifyChangeGroup: false,
    notifyChangeFilter: false,
    notifyChangeOrder: false
  },
  action
) {
  switch (action.type) {
    case SET_LOOKAHEAD_ASSISTANCE_ACTIVATED_COLS:
      return {
        ...state,
        activatedColumns: action.payload
      };
    case SET_LOOKAHEAD_ASSISTANCE_RANGE_FILTERED:
      return {
        ...state,
        isRangeDateFiltered: action.payload.boolean,
        dateRangeToFilter: action.payload.dateRange
      };
    case NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE:
      return {
        ...state,
        notifyChange: !state.notifyChange
      };
    case NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_GROUP:
      return {
        ...state,
        notifyChangeGroup: !state.notifyChangeGroup
      };
    case NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_FILTER:
      return {
        ...state,
        notifyChangeFilter: !state.notifyChangeFilter
      };
    case NOTIFY_LOOKAHEAD_ASSISTANCE_UPDATE_ORDER:
      return {
        ...state,
        notifyChangeOrder: !state.notifyChangeOrder
      };
    default:
      return state;
  }
}

export default lookaheadReducer;
